const stickTopSentinelEl = document.createElement("div");
stickTopSentinelEl.style.height = "calc(var(--header-height) - 4px)";
stickTopSentinelEl.style.position = "absolute";
document.body.appendChild(stickTopSentinelEl);

function isElementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < window.scrollY + window.innerHeight &&
    left < window.scrollX + window.innerWidth &&
    top + height > window.scrollY &&
    left + width > window.scrollX
  );
}

function minmax(min, max, num) {
  if (num < min) return min;
  if (num > max) return max;
  return num;
}

window.addEventListener("scroll", () => {
  const tableEls = document.querySelectorAll(".timetable__table");
  const topDistance = stickTopSentinelEl.getBoundingClientRect().height;

  tableEls.forEach((tableEl) => {
    const tbodyEl = tableEl.querySelector("tbody");

    if (tbodyEl) {
      const tbodyHeight = tbodyEl.getBoundingClientRect().height;
      const stickyThresholtMet = tbodyHeight > window.innerHeight * 0.25;

      if (isElementInViewport(tableEl) && stickyThresholtMet) {
        const theadEl = tableEl.querySelector("thead");
        const boundaryTop = (tableEl.getBoundingClientRect().top - topDistance) * -1;

        theadEl.style.transform =
          "translate(0," + minmax(0, tbodyHeight - window.innerHeight * 0.3, boundaryTop) + "px)";
      }
    }
  });
});
